import Vue from "vue";

Vue.filter("itemName", ({ texts:{ name1, name2, name3 }, variation:{ name } }, selectedName = App.config.item.itemName) =>
{
    let itemName = "";

    if (selectedName === 1 && name2 !== "")
    {
        itemName = name2;
    }
    else if (selectedName === 2 && name3 !== "")
    {
        itemName = name3;
    }
    else
    {
        itemName = name1;
    }

    if (name && name.length)
    {
        const filterStrings = ["strecke", "auslauf", "colli", "bestell", "\\[", "\\]"];

        const regex = new RegExp(filterStrings.join("|"), "i");

        if (regex.test(name))
        {
            return itemName;
        }


        if (name.substr(0, 1) === ",")
        {
            // [NAME][addition]
            itemName = `${itemName}${name}`;
        }
        else
        {
            // [NAME] [addition]
            itemName = `${itemName} ${name}`;
        }
    }

    return itemName;
});
